'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:ui:alert');
}

var _invoke = require('../invoke');

/**
 * 单按钮弹窗，类似 alert
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof ui
 * @static
 * @name alert
 * @param {String} message 弹窗信息
 * @param {String} [title] 弹窗标题，可选
 * @param {Array} button 按钮
 * @return {Undefined}
 * @example
 *  hbnb.ui.alert('message', ['title'], [{
 *      label: '确定',
 *      callback: function() {
 *          console.log('clicked');
 *      }
 *  }]);
 */
module.exports = function(message, title, button) {
    if (process.env.NODE_ENV !== 'production') {
        debug('message is %j', message);
        debug('title is %j', title);
        debug('button is %j', button);
    }

    if (!button) {
        button = title;
        title = '';
    }

    // fix: button should be an array
    if (Object.prototype.toString.call(button) === "[object Object]") {
        button = [button];
    }

    _invoke('ui', 'alert', {
        message: message,
        title: title,
        buttons: button
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/ui/alert.js
// module id = 647
// module chunks = 0